export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/4fb029f8b7475a441bcc77c7d98e24f7.png";